export const HEADER_NAVIGATION_HEIGHT = "56px";
